/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { NgModule } from '@angular/core';
import { BuilderSharedModule } from '@gh/builder-shared';
import { BuilderSetupOfficePermissionsRoutingModule } from './builder-setup-office-permissions-routing.module';
import { OfficeModulePermissionsDetailsComponent } from './components/office-module-permissions-details/office-module-permissions-details.component';
import { OfficePermissionsMasterZoneListComponent } from './components/office-permissions-master-zone-list/office-permissions-master-zone-list.component';
import { OfficeModulePermissionDetailsBusinessService } from './resources/office-module-permission-details-business.service';
import { OfficePermissionsMasterZoneListBusinessService } from './resources/office-permissions-master-zone-list-business.service';

@NgModule({
  imports: [
    BuilderSharedModule.forChild(),
    BuilderSetupOfficePermissionsRoutingModule,
  ],
  providers: [
    OfficePermissionsMasterZoneListBusinessService,
    OfficeModulePermissionDetailsBusinessService,
  ],
  declarations: [
    OfficeModulePermissionsDetailsComponent,
    OfficePermissionsMasterZoneListComponent,
  ],
})
export class BuilderSetupOfficePermissionsModule {
}
